<template lang="pug">
v-dialog(
  v-model="abertoInterno"
  persistent
  max-width="560"
  content-class="map-coordenadas-dialog-content"
)
  v-card.dialog-card
    v-card-title.dialog-title(:class="{ 'dialog-title-mobile': $vuetify.breakpoint.xsOnly }")
      span.dialog-title-text Alterar latitude e longitude
      v-spacer
      v-btn(icon, :disabled="loading", @click="fechar")
        v-icon mdi-close

    v-card-text.dialog-content(:class="{ 'dialog-content-mobile': $vuetify.breakpoint.xsOnly }")
      template(v-if="item")
        .dialog-ref-card
          .card-nomes
            .card-razao {{ item.razaoempresa || item.fantasiaempresa || 'Não informado' }}
            .card-fantasia {{ item.fantasiaempresa || item.nomecliente || 'Não informado' }}
          .meta-row
            v-chip.softhouse-badge(
              v-if="item.softhouse"
              small
              label
              dark
              :color="corSoftwareHouse(item.softhouse)"
            ) {{ item.softhouse }}
            v-chip.version-badge(
              v-if="item.versao"
              small
              label
              color="grey lighten-3"
            )
              span.version-text {{ item.versao }}
            .meta-divider(v-if="item.versao && item.tipoempresa")
            v-chip.tipo-badge(
              v-if="item.tipoempresa"
              small
              label
              outlined
            ) {{ item.tipoempresa }}

      .dialog-descricao
        p.mb-0 Preencha latitude e longitude para atualizar a localização no mapa.

      v-row.mt-2.dialog-fields-row(:dense="$vuetify.breakpoint.xsOnly")
        v-col(cols="12" sm="6", class="dialog-field-col")
          v-text-field(
            v-model="form.latitude"
            label="Latitude"
            outlined
            dense
            hide-details="auto"
            :disabled="loading"
            placeholder="-27.123456"
          )
        v-col(cols="12" sm="6", class="dialog-field-col")
          v-text-field(
            v-model="form.longitude"
            label="Longitude"
            outlined
            dense
            hide-details="auto"
            :disabled="loading"
            placeholder="-48.654321"
          )

      .dialog-hint.mt-4
        v-icon.dialog-hint-icon(small, color="blue") mdi-information
        .dialog-hint-text
          div Use ponto decimal, com no mínimo 6 casas após o ponto.
          div Exemplo válido: -27.123456

    .dialog-actions(:class="{ 'dialog-actions-mobile': $vuetify.breakpoint.xsOnly }")
      v-spacer(v-if="!$vuetify.breakpoint.xsOnly")
      v-btn(
        outlined
        color="primary"
        class="dialog-action-btn"
        :disabled="loading"
        @click="fechar"
      ) Cancelar
      v-btn(
        color="success"
        outlined
        class="dialog-action-btn"
        :loading="loading"
        @click="salvar"
      ) Salvar
</template>

<script>
import { CORES_SISTEMA } from "./mapConfig";

const COORDENADA_REGEX = /^-?\d+\.\d{6,}$/;

export default {
  name: "MapCoordenadasDialog",

  props: {
    value: {
      type: Boolean,
      default: false
    },
    item: {
      type: Object,
      default: null
    },
    loading: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      abertoInterno: false,
      form: {
        latitude: "",
        longitude: ""
      }
    };
  },

  watch: {
    value: {
      immediate: true,
      handler(valor) {
        this.abertoInterno = valor;
        if (valor) {
          this.preencherFormulario();
        }
      }
    },

    abertoInterno(valor) {
      this.$emit("input", valor);
    },

    item() {
      if (this.abertoInterno) {
        this.preencherFormulario();
      }
    }
  },

  methods: {
    corSoftwareHouse(softhouse) {
      return CORES_SISTEMA[softhouse] || "#757575";
    },

    preencherFormulario() {
      const localizacao =
        this.item && Array.isArray(this.item.localizacao) ? this.item.localizacao : [];

      this.form.latitude = this.formatarCoordenada(localizacao[0]);
      this.form.longitude = this.formatarCoordenada(localizacao[1]);
    },

    formatarCoordenada(valor) {
      if (valor == null || valor === "") return "";
      return String(valor);
    },

    coordenadaValida(valor) {
      return COORDENADA_REGEX.test(String(valor || "").trim());
    },

    salvar() {
      const latitude = String(this.form.latitude || "").trim();
      const longitude = String(this.form.longitude || "").trim();

      if (!this.coordenadaValida(latitude) || !this.coordenadaValida(longitude)) {
        this.$toast.error("Use o formato -27.123456 com ponto decimal e no mínimo 6 casas");
        return;
      }

      this.$emit("save", {
        latitude,
        longitude,
        localizacao: [latitude, longitude]
      });
    },

    fechar() {
      this.abertoInterno = false;
    }
  }
};
</script>

<style scoped>
.dialog-card {
  width: 100%;
}

.dialog-title {
  padding: 20px 24px 8px;
}

.dialog-title-mobile {
  padding: 20px 20px 8px;
}

.dialog-title-text {
  font-size: 16px;
  font-weight: 700;
}

.dialog-content {
  padding: 8px 24px 12px !important;
}

.dialog-content-mobile {
  padding: 8px 20px 12px !important;
}

.dialog-ref-card {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 12px 14px;
  border: 1px solid rgba(0, 0, 0, 0.12);
  border-radius: 4px;
}

.card-razao {
  font-size: 14px;
  font-weight: 700;
  color: rgba(0, 0, 0, 0.87);
  line-height: 1.4;
  letter-spacing: -0.01em;
}

.card-fantasia {
  font-size: 12px;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.5);
  line-height: 1.4;
  margin-top: 2px;
  text-transform: uppercase;
}

.meta-row {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.softhouse-badge {
  font-weight: 500 !important;
  letter-spacing: 0.02em;
}

.version-badge {
  font-weight: 700 !important;
}

.version-text {
  font-family: monospace;
  font-weight: 700;
  font-size: 12px;
  color: rgba(0, 0, 0, 0.9);
}

.meta-divider {
  width: 1px;
  height: 18px;
  background: rgba(0, 0, 0, 0.2);
}

.tipo-badge {
  font-weight: 600 !important;
}

.dialog-descricao {
  margin-top: 14px;
  font-size: 14px;
  line-height: 1.5;
  color: rgba(0, 0, 0, 0.68);
}

.dialog-field-col {
  padding-top: 4px;
  padding-bottom: 4px;
}

.dialog-fields-row {
  margin-left: -6px;
  margin-right: -6px;
}

.dialog-fields-row > .dialog-field-col {
  padding-left: 6px;
  padding-right: 6px;
}

.dialog-hint {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 12px;
  border: 1px solid rgba(33, 150, 243, 0.45);
  border-radius: 4px;
  background: rgba(33, 150, 243, 0.04);
  color: rgba(0, 0, 0, 0.72);
  font-size: 13px;
  line-height: 1.5;
}

.dialog-hint-icon {
  align-self: center;
  margin-top: 0;
  flex-shrink: 0;
}

.dialog-hint-text {
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 2px;
  line-height: 1.5;
}

.dialog-actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 8px 24px 20px;
  gap: 10px;
}

.dialog-actions-mobile {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  padding: 8px 20px 20px;
  gap: 10px;
}

.dialog-action-btn {
  margin: 0 !important;
  min-width: 120px !important;
}

::v-deep .map-coordenadas-dialog-content .dialog-actions-mobile .dialog-action-btn {
  width: 100%;
  min-width: 0 !important;
  max-width: none !important;
  min-height: 40px;
  height: 40px;
  justify-self: stretch;
}

::v-deep .map-coordenadas-dialog-content .dialog-actions-mobile .dialog-action-btn .v-btn__content {
  width: 100%;
  justify-content: center;
}

::v-deep .map-coordenadas-dialog-content .dialog-actions-mobile .v-spacer {
  display: none;
}
</style>
